var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdentity = function SvgIdentity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.084 2.5h15.833M3.75 2.5v9.166c0 1.94.359 2.574 2.023 3.573l2.512 1.507c.836.501 1.253.752 1.715.752s.88-.25 1.715-.752l2.512-1.507c1.664-.999 2.023-1.633 2.023-3.573V2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m10.504 6.671.513 1.035c.07.144.257.283.414.309l.93.156c.595.1.735.535.306.964l-.723.73a.64.64 0 0 0-.151.532l.207.902c.163.715-.213.991-.84.618l-.872-.52a.63.63 0 0 0-.578 0l-.872.52c-.624.373-1.003.094-.84-.617l.207-.903a.64.64 0 0 0-.151-.533l-.723-.729c-.426-.429-.29-.864.306-.964l.93-.156a.64.64 0 0 0 .411-.309l.514-1.035c.28-.561.734-.561 1.012 0"
  })));
};
export default SvgIdentity;